module.exports = __webpack_public_path__ + "img/14b.f323761a.png";